module.exports = __webpack_public_path__ + "static/media/QRcode1.677721dc.png";